// this is a hack to let the QuestionEditor determine if a question is new or existing
import { NEW_QUESTION_PREFIX } from "../../../../constants/questions";
import { Question } from "../../../../types/Questions";

export const isNewQuestion = (question: Question) => question.id?.startsWith(NEW_QUESTION_PREFIX);
